import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'


// 路由组件
import login from '@/components/login'
import password from '@/components/password'
import home from '@/components/home'
import main from '@/components/main'
import nursingIndex from '@/components/nursing/index'
import nursingOne from '@/components/nursing/nursing-one'
import nursingOneImplement from '@/components/nursing/nursing-one-implement'
import nursingBatch from '@/components/nursing/nursing-batch-implement'
import implementHistory from '@/components/implement-history'
import nursingHistory from '@/components/nursing/history'
import photo from '@/components/photo'
import shift from '@/components/shiftExchange/shift'
import nurseShiftExchange from '@/components/shiftExchange/nurseShiftExchange'
import floorShift from '@/components/shiftExchange/floorShift'
import shiftExchangeDetails from '@/components/shiftExchange/shiftExchangeDetails'
import addShift from '@/components/shiftExchange/addShift'
import record from '@/components/record/index'
import recordDetail from '@/components/record/detail'
Vue.use(Router)
let router=new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '',
      name: 'home',
      component: home,
      children: [
        {
          path: '/login',
          name: 'login',
          meta:{
            title:'登录',
            headIcon:false
          },
          component: login
        },
        {
          path: '/password',
          name: 'password',
          meta: {
            title: '找回密码',
            headIcon: true
          },
          component: password
        },
        {
          path: '/main',
          name: 'main',
          meta:{
            title:'主页',
            headIcon:false
          },
          component: main
        },
        {
          path: 'nursing',
          name:'nursingIndex',
          component: nursingIndex,
          children: [
            {
              path: 'one',
              name:'nursingOne',
              meta:{
                title:'长者护理'
              },
              component: nursingOne,
            },
            {
              path: 'one/implement',
              name:'nursingOneImplement',
              meta:{
                title:'长者护理'
              },
              component: nursingOneImplement,
            },
            {
              path: 'batch/implement',
              name:'nursingBatch',
              meta:{
                title:'长者护理'
              },
              component: nursingBatch,
            },{
              path: 'history',
              name:'nursingHistory',
              meta:{
                title:'长者护理'
              },
              component: nursingHistory,
            }
          ]
        },
        {
          path: '/implementHistory',
          name:'implementHistory',
          meta:{
            title:'最近输入'
          },
          component: implementHistory,
        },
        {
          path: '/photo',
          name:'photo',
          meta:{
            title:'幸福相册',
            headIcon:true
          },
          component: photo,
        },
        {
          path: 'shift',
          component: shift,
          children: [
            {
              path: '/shiftExchange/nurseShiftExchange',
              name:'nurseShiftExchange',
              meta:{
                title:'护士交班',
                headIcon:true,
                goHome:true
              },
              component: nurseShiftExchange,
            },
            {
              path: '/shiftExchange/floorShift',
              name:'floorShift',
              meta:{
                title:'楼层交班',
                headIcon:true,
                goHome:true
              },
              component: floorShift,
            },
            {
              path: '/shiftExchange/shiftExchangeDetails',
              name:'shiftExchangeDetails',
              meta:{
                title:'交班详情',
                headIcon:true
              },
              component: shiftExchangeDetails,
            },
          ]
        },
        {
          name:'record',
          path: '/record',
          meta:{
            title:'医疗档案',
          },
          component: record,
        },
        {
          name: 'detail',
          path: '/record/detail',
          meta: {
            title: '医疗档案明细',
          },
          component: recordDetail,
        },



        {
          path: '/shiftExchange/addShift',
          name:'addShift',
          meta:{
            title:'新增交班',
            headIcon:true
          },
          component: addShift,
        },
        // {
        //   path: '/shiftExchange/floorShift',
        //   name:'floorShift',
        //   meta:{
        //     title:'楼层交班',
        //     headIcon:true
        //   },
        //   component: floorShift,
        // },
        // {
        //   path: '/shiftExchange/shiftExchangeDetails',
        //   name:'shiftExchangeDetails',
        //   meta:{
        //     title:'交班详情',
        //     headIcon:true
        //   },
        //   component: shiftExchangeDetails,
        // },
      ]
    },
    {
      path: '*',
      redirect: '/login'
    },

  ]
})
const whiteList = ['/login'] // 路由的白名单
router.beforeEach((to, from, next) => {
  console.log(store.state);
  /* 路由发生变化修改页面title */
  // 登录了
  if (store.state.user) {
    next()
  } else {
    // 未登录
    // 白名单
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js